"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var OnboardingBanner_1 = __importDefault(require("Dashboard/OnboardingBanner/OnboardingBanner"));
var react_1 = __importDefault(require("react"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var styles = __importStar(require("./PageDashboardOnboardingBanner.css"));
var PromptTypes_1 = require("Prompt/PromptTypes");
var inversify_react_1 = require("inversify-react");
var moment_1 = __importDefault(require("moment"));
var EditorExperienceActionCard_1 = require("Dashboard/OnboardingBanner/ActionCards/EditorExperienceActionCard");
var BrandSetupActionCard_1 = require("Dashboard/OnboardingBanner/ActionCards/BrandSetupActionCard");
var GetHelpActionCard_1 = require("Dashboard/OnboardingBanner/ActionCards/GetHelpActionCard");
var DocConversionActionCard_1 = require("Dashboard/OnboardingBanner/ActionCards/DocConversionActionCard");
var CreateFromTemplateActionCard_1 = require("Dashboard/OnboardingBanner/ActionCards/CreateFromTemplateActionCard");
var getActionCards = function (rootDataStore, promptId) {
    var userDataStore = rootDataStore.userDataStore;
    var accountDataStore = rootDataStore.getAccountDataStore();
    var isTrial = accountDataStore.getPlanDisplayName() === "Trial";
    if (!isTrial) {
        return [
            react_1.default.createElement(EditorExperienceActionCard_1.EditorExperienceActionCard, { promptId: promptId }),
            react_1.default.createElement(CreateFromTemplateActionCard_1.CreateFromTemplateActionCard, { promptId: promptId }),
            react_1.default.createElement(GetHelpActionCard_1.GetHelpActionCard, { promptId: promptId }),
        ];
    }
    if (userDataStore.isAdmin) {
        return [
            react_1.default.createElement(EditorExperienceActionCard_1.EditorExperienceActionCard, { promptId: promptId }),
            react_1.default.createElement(BrandSetupActionCard_1.BrandSetupActionCard, { promptId: promptId }),
            react_1.default.createElement(DocConversionActionCard_1.DocConversionActionCard, { promptId: promptId }),
        ];
    }
    return [
        react_1.default.createElement(EditorExperienceActionCard_1.EditorExperienceActionCard, { promptId: promptId }),
        react_1.default.createElement(GetHelpActionCard_1.GetHelpActionCard, { promptId: promptId }),
        react_1.default.createElement(DocConversionActionCard_1.DocConversionActionCard, { promptId: promptId }),
    ];
};
var PageDashboardOnboardingBanner = function () {
    var promptId = PromptTypes_1.PromptId.PagesDashboardOnboardingBanner;
    var rootDataStore = (0, inversify_react_1.useInjection)("rootDataStore");
    var userDataStore = rootDataStore.userDataStore;
    var bannerReleaseDate = (0, moment_1.default)("2024-02-19T03:00:00.000Z");
    var isOldUser = (0, moment_1.default)(userDataStore.createdAt).add(14, "days").isBefore(bannerReleaseDate);
    return (react_1.default.createElement("div", { className: styles.bannerContainer },
        react_1.default.createElement("div", { className: styles.banner },
            react_1.default.createElement(OnboardingBanner_1.default, { enabled: !isOldUser, title: react_1.default.createElement("div", null,
                    react_1.default.createElement("span", { className: styles.gradientHeadingText }, "Welcome, ".concat(userDataStore.firstName, ". ")),
                    " Get started with Qwilr."), description: react_1.default.createElement("div", { className: styles.bannerDescription },
                    react_1.default.createElement(icons_1.Spark, { size: icons_1.IconSize.Small }),
                    react_1.default.createElement("span", null, " Recommended next steps based on your profile")), promptId: promptId, actionCards: getActionCards(rootDataStore, promptId) }))));
};
exports.default = PageDashboardOnboardingBanner;
